// extracted by mini-css-extract-plugin
export default {"mainMenu":"menu_mainMenu__NkOcA","logo":"menu_logo__VdUr1","menuItem":"menu_menuItem__pi7LJ","menuItem_active":"menu_menuItem_active__Ok-g8"};